import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { TierProgramRow } from "@colab/shared";

// GET /api/admin/tiers/programs — list of all tier programs with aggregate
// counts (tier_count + assignment_count) per row.
//
// Phase 7 sub-bucket 12. Counts are layered on by the worker via a single
// batched scan, not the legacy N+1 fan-out. The same key
// (`queryKeys.tiers.programs.list()`) is invalidated by every Phase 6 tier
// mutation hook, so the aggregate list refreshes after creates/archives
// without further wiring.
export type AdminTierProgramListRow = TierProgramRow & {
  tier_count: number;
  assignment_count: number;
};

export function usePrograms() {
  return useQuery<AdminTierProgramListRow[], ApiClientError>({
    queryKey: queryKeys.tiers.programs.list(),
    queryFn: () => apiFetch<AdminTierProgramListRow[]>("/admin/tiers/programs"),
  });
}
